import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import { ScPaymentFormInput } from '@innogy/sitecore-forms/models';
import { ibanConverter } from '@innogy/utils-deprecated';
import { FormState } from 'ngrx-forms';
import { TextComponent } from '@innogy/common-ui/forms';

@Component({
  selector: 'wl-sc-payment[control][trackStep][fields]',
  templateUrl: './sc-payment.component.html',
  standalone: true,
  imports: [TextComponent],
})
export class ScPaymentComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScPaymentFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  public readonly _ibanConverter = ibanConverter;
}
